import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import {
  initialiseSegment,
  OneTrustConsent,
  GTMContainer,
} from '@crunchyroll/cr-static-shared-components'

import favicon from 'images/favicon.png'
import { languageList } from 'intl'
import Metadata from 'components/seo/metadata'
import { useSiteMetadata } from 'hooks/use-site-metadata'

const PageComponent = ({ pathname = '', element }) => {
  const {
    assetPrefix,
    siteMetadata: { baseUrl: url },
  } = useSiteMetadata()

  const [isIdle, setIsIdle] = useState(false)

  const path = pathname.replace(assetPrefix, '')
  let canonicalHref = `${url}${pathname}`

  const langList = !Array.isArray(languageList)
    ? Object.keys(languageList)
    : languageList
  const localized = langList.find((lang) => path.includes(`/${lang}/`))
  const isDefaultPage = localized ? false : true
  if (isDefaultPage) canonicalHref = `${url}${assetPrefix}${path}`

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://platform.twitter.com/widgets.js'
    script.async = true
    script.defer = true
    document.body.appendChild(script)
  }, [])

  useEffect(() => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => setIsIdle(true))
    } else {
      setTimeout(() => setIsIdle(true), 2000)
    }
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      initialiseSegment(false)
    }
  }, [])

  return (
    <>
      {isIdle && <OneTrustConsent />}

      <Helmet>
        <link
          rel="preconnect"
          href="https://a.storyblok.com"
          crossorigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://cdn.segment.com"
          crossorigin="anonymous"
        />

        <link
          rel="preconnect"
          href="https://www.googletagmanager.com"
          crossorigin="anonymous"
        />

        <link rel="icon" href={favicon} />
        <link rel="canonical" href={canonicalHref} />
        <meta property="og:url" content={canonicalHref} />
      </Helmet>

      {isIdle && <GTMContainer />}
      {isDefaultPage && <Metadata />}
      {element}
    </>
  )
}

PageComponent.propTypes = {
  pathname: PropTypes.string,
  element: PropTypes.node.isRequired,
}

export default PageComponent
